<template>
  <div class="yxtbiz-aibox-unify" ref="aiboxRef">
    <div class="container" :class="{ 'fullscreen': isFullscreen }" v-loading="dataLoading">
      <transition name="panel-slide">
        <div class="panel" v-if="isFullscreen" v-show="isExpand">
          <div class="aibox-info">
            <div class="app-info">
              <yxtf-portrait size="72px" class="portrait" :imgUrl="appData.icon"></yxtf-portrait>
              <div class="app-name ellipsis">{{ appData.appName }}</div>
            </div>
          </div>
          <div class="option">
            <div class="option-left"></div>
            <div class="option-right">
              <div @click="isExpand = false">
                <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" icon-class="shrink1" class="color-gray-7 hover-primary-6 hand icon"/>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="expand-btn hand" v-show="isFullscreen && !isExpand"  @click="isExpand = true">
        <span class="text">展开</span>
        <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" icon-class="expand1"/>
      </div>
      <div class="main">
        <div class="header">
          <div class="left" :class="{ 'hidden': isFullscreen }">
            <yxtf-portrait size="36px" :imgUrl="appData.icon"></yxtf-portrait>
            <span class="app-name ellipsis">{{ appData.appName }}</span>
          </div>
          <div class="right">
            <span @click="toggleFullscreen">
              <yxtf-svg :width="iconSize" :height="iconSize" :remote-url="iconUrl" :icon-class="isFullscreen ? 'ai-window' : 'ai-screen'" class="color-gray-7 hover-primary-6 hand icon"/>
            </span>
            <span @click="onClose">
              <yxtf-svg :width="iconSize" :height="iconSize" :remote-url="iconUrl" icon-class="ai-closed" class="color-gray-7 hover-primary-6 hand icon"/>
            </span>
          </div>
        </div>
        <yxtf-scrollbar fitHeight class="chat-container">
          <chat-box ref="chatBoxRef" :showPortrait="isFullscreen" :loading="qaLoading" :chat-list="qaList" :receive-status="receiveStatus" :service-img="appData.icon">
            <template v-slot:top-option="slotProps">
              <div>
                <div class="top-opt-btn icon-btn-status" :class="{'icon-btn-active': slotProps.data.appraisement === 1, 'icon-btn-disabled': slotProps.data.appraisement === 2}" @click="onFeedbackItem(slotProps, 1)">
                  <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" :icon-class="slotProps.data.appraisement ? 'great' : 'great-outline'"/>
                </div>
                <div class="top-opt-btn icon-btn-status" :class="{'icon-btn-active': slotProps.data.appraisement === 2, 'icon-btn-disabled': slotProps.data.appraisement === 1}" @click="onFeedbackItem(slotProps, 2)">
                  <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" :icon-class="slotProps.data.appraisement ? 'bad' : 'bad-outline'"/>
                </div>
              </div>
            </template>
            <template v-slot:option="slotProps">
              <div class="option-left">
                <div v-if="slotProps.data.showStaffservice && slotProps.index === qaList.length - 1" :class="{'font-size-16': isFullscreen}">
                  <span class="tips">抱歉，目前无法解答您的问题，您可以</span>
                  <yxtf-link @click="onStaffservice" type="primary" :underline="false">转人工</yxtf-link>
                </div>
              </div>
              <div class="option-right" v-show="apiMap.appraise && !slotProps.data.appraisement">
                <div class="option-btn-mini icon-btn-status" :class="{'icon-btn-active': slotProps.data.appraisement === 1, 'icon-btn-disabled': slotProps.data.appraisement === 2}" @click="onFeedbackItem(slotProps, 1)">
                  <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" :icon-class="slotProps.data.appraisement ? 'great' : 'great-outline'"/>
                </div>
                <div class="option-btn-mini icon-btn-status" :class="{'icon-btn-active': slotProps.data.appraisement === 2, 'icon-btn-disabled': slotProps.data.appraisement === 1}" @click="onFeedbackItem(slotProps, 2)">
                  <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" :icon-class="slotProps.data.appraisement ? 'bad' : 'bad-outline'"/>
                </div>
              </div>
            </template>
            <template v-slot:staffservice="slotProps">
              <div>
                <div style="display:inline-block; vertical-align: middle;">好的，请点击唤起客服</div>
                <yxtf-link :class="{'font-size-16': isFullscreen}" style="margin-left: 12px;"  @click="onStaffservice" type="primary" :underline="false">转人工</yxtf-link>
              </div>
            </template>
          </chat-box>
          <div class="process-tips" v-show="processFinish">
            <yxt-alert bg-color='#F5F5F5' :closable="false">
              <template slot="title" >
                <span style="color:#595959;margin-right: 10px;">流程已结束，点击按钮重新开始流程</span> <yxt-button @click="resetProcess" type="text">重新开始</yxt-button>
              </template>
            </yxt-alert>
          </div>
        </yxtf-scrollbar>
        <chat-input ref="chatInputRef" :disabled="qaLoading || processFinish" @send="onGetAnswer"></chat-input>
      </div>
    </div>
    <yxt-dialog
      title="模型提示"
      :visible="modelMsgDialogVisible"
      :cutline="false"
      :show-close="false"
      width="700px"
      >
      <div> {{ modelMsg }}</div>
      <template slot="footer" >
        <yxt-button type="primary" @click="assistantContinue">确定</yxt-button>
      </template>
    </yxt-dialog>
  </div>
</template>

<script>
import { ICON_PATH, SOURCE } from './config';
import chatBox from './components/chat-box.vue';
import chatInput from './components/chat-input.vue';
import request from './service';
import { getStaticBaseUrl } from './service';
import { throttle } from 'throttle-debounce';

const SUCCESS_CODE = 'AI_200';
const BREAK_CODE = 'AI_532';
const END_CODE = 'AI_506';
const WARNING_CODE = [];
const IGNORE_CODE = [SUCCESS_CODE, BREAK_CODE, END_CODE];

export default {
  name: 'YxtbizAiboxUnify',
  components: {
    chatBox,
    chatInput
  },
  props: {
    appId: {
      type: String,
      required: true
    },
    recordId: {
      type: String,
      default: ''
    },
    // 接口地址 {appDetail:'', 'assistantQa': '', 'appraise': '', sessionGenerate: ''}
    apiMap: {
      type: Object,
      required: true
    },
    platform: {
      type: String,
      default: 'aibox-unify-component'
    },
    carryParmas: {
      type: Object,
      default: () => ({})
    },
    enableStaffservice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconUrl: `${getStaticBaseUrl()}ufd/55a3e0/assistent/pc/svg`,
      ICON_PATH,
      isFullscreen: false,
      isExpand: true,
      appData: {},
      qaList: [],
      dataLoading: true,
      qaLoading: false,
      receiveStatus: 1,
      sessionId: '',
      currNodeInstanceId: 'start-0',
      processStatus: '',
      processFinish: false,
      modelMsgDialogVisible: false,
      modelMsg: '',
      observer: null
    };
  },
  computed: {
    iconSize() {
      return this.isFullscreen ? '24px' : '20px';
    },
    gptImg() {
      return this.appData.icon;
    },
    userImg() {
      return localStorage.getItem('imgUrl') || 'https://aibox.bj.bcebos.com//yxt/appIcon/appIcon/011n/美美.jpg';
    },
    finalRecordId() {
      return this.recordId || this.sessionId;
    },
    qaListLog() {
      return this.qaList.filter(item => !['logs', 'tips', 'staffservice'].includes(item.type)).map(item => {
        return {role: item.role, content: item.content, appraisement: item.appraisement};
      });
    }
  },
  mounted() {
    this.getAppData();
    try {
      const targetElement = this.$refs.aiboxRef;
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            this.goToBottom();
          }
        });
      });
      this.observer.observe(targetElement, {attributes: true});
    } catch (error) {
      console.log('🔥 不支持observer');
    }
  },
  beforeDestroy() {
    this.observer && this.observer.disconnect();
  },
  methods: {
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      this.goToBottom();
    },
    onClose() {
      this.$emit('close');
    },
    getAppData() {
      this.dataLoading = true;
      request.get(this.apiMap.appDetail, {
        params: {id: this.appId}
      }).then(res => {
        if (res.code === 0) {
          this.appData = res.data;
          this.appData.example = JSON.parse(this.appData.example || '[]');
          if (this.appData.type === 'assistant') this.onGetAnswer();
        } else {
          this.$message.warning('应用信息获取失败！');
        }
      }).finally(() => {
        this.dataLoading = false;
      });
      // Promise.all([getAppInfo(), getRecordHistory(localStorage.getItem('userId'))]).then(([appData, recordHistory]) => {
      //   if (appData.code === 0) this.appData = appData.data;
      //   this.appData.example = JSON.parse(this.appData.example || '[]');
      //   const lastIndex = this.qaList.length - 1 || 0;
      //   this.appData.example.forEach((item) => {
      //     this.qaList[lastIndex].content = this.qaList[lastIndex].content + `\n - • ${item.question}`;
      //   });
      //   if (recordHistory && recordHistory.length && recordHistory.length > 0) {
      //     this.qaList.unshift(...recordHistory.map(item => {
      //       item.receiveState = 4;
      //       item.appraisement = 0;
      //       item.type = 'logs';
      //       return item;
      //     }));
      //   }
      //   this.goToBottom();
      // }).finally(() => {
      //   this.dataLoading = false;
      // });
    },
    onStaffservice() {
      this.$emit('staffService', this.finalRecordId);
    },
    onFeedbackItem(item, status) {
      const { data, index } = item;
      if (data.appraisement) return;
      if (status === 2) item.data.showStaffservice = true;
      this.qaList[index].appraisement = status;
      // feedbackItem(data.recordId, status).then(res => {
      //   if (res === 'SUCCESS') {
      //     this.$message.success('反馈成功！');
      //   } else {
      //     this.$message.error('反馈失败！');
      //     this.qaList[index].appraisement = 0;
      //   }
      // });
    },
    clearQaList() {
      this.qaList = [];
    },
    buildChatItem(role, content) {
      return {
        role,
        content,
        type: 'chat',
        appraisement: 0,
        showStaffservice: false
      };
    },
    generateSession(name) {
      return request.post(this.apiMap.sessionGenerate, { appId: this.appId, name }).then((res) => {
        if (res.code === 200) return res.data;
      });
    },
    getTextStream(url, params, {callback, parseHandle}) {
      const controller = new AbortController();
      const receivedData = {data: ''};
      const info = {};
      const stopResponse = (appendText) => {
        if (appendText) receivedData.data += `\n${appendText}`;
        callback(receivedData.data, false, info);
      };

      const parseText = (rawData) => {
        const resData = JSON.parse(rawData.replace(/^data:/, ''));
        if (resData.recordId) info.recordId = resData.recordId;
        if (resData.code === BREAK_CODE) {
          resData.curr_node_instanceId = resData.data;
        }
        parseHandle && parseHandle(resData, receivedData);
        // 临时处理异常
        if (resData.code && !IGNORE_CODE.includes(resData.code)) {
          const errorMsg = `${resData.code} - ${resData.msg}`;
          stopResponse(errorMsg);
          console.log('🔥 异常信息 - ', resData);
          return;
        }
        if (resData.error_code) {
          const errorMsg = `${resData.error_code} - ${resData.error_msg}`;
          stopResponse(errorMsg);
          console.log('🔥 异常信息 - ', resData);
          return;
        }

        if (resData.choices && resData.choices[0]) {
          const choicesData = resData.choices[0];
          const errorCode = choicesData.error_code;
          const isWarning = WARNING_CODE.includes(errorCode);
          if (errorCode) {
            const em = choicesData.error_message || '模型服务异常，请稍后再试!';
            const errorMsg = isWarning ? em : `${errorCode} - ${em}`;
            stopResponse(errorMsg);
          }
          if (choicesData.delta && choicesData.delta.content) {
            receivedData.data += choicesData.delta.content;
          }
          if (choicesData.finish_reason === 'stop') {
            stopResponse();
            return;
          }
          callback(receivedData.data, true, info);
        }
      };

      const parseTextSafe = (rawData) => {
        try {
          parseText(rawData);
        } catch (error) {
          // const msg = '数据解析异常！';
          // stopResponse(msg);
          stopResponse();
          console.log('🔥 数据解析异常 - ', rawData);
        }
      };
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Token': localStorage.getItem('token'),
          'Source': SOURCE
        },
        signal: controller.signal,
        body: JSON.stringify(params)
      })
        .then(async(resp) => {
          this.receiveStatus = 3;
          if (!resp.ok) {
            const msg = resp.status + resp.statusText;
            stopResponse(msg);
            return;
          }
          const reader = resp.body.getReader();
          const decoder = new TextDecoder();
          let prevData = '';
          for (;;) {
            const { done, value } = await reader.read();
            if (done) {
              if (prevData) parseTextSafe(prevData);
              stopResponse();
              break;
            }
            let rawData = decoder.decode(value, { stream: true });
            const rawDataArr = (prevData + rawData).split('\n\n');
            if (rawDataArr.length === 1) {
              const rawDataItem = rawDataArr[0];
              try {
                parseText(rawDataItem);
                prevData = '';
              } catch (error) {
                prevData = rawDataItem;
                continue;
              }
            } else if (rawDataArr.length > 1) {
              const lastData = rawDataArr[rawDataArr.length - 1].replace(/^data:/, '');
              try {
                JSON.parse(lastData);
                prevData = '';
              } catch (error) {
                prevData = rawDataArr.pop();
              }
              rawDataArr.forEach((rawDataItem) => {
                parseTextSafe(rawDataItem);
              });
            }
          }
        })
        .catch((e) => {
          console.log('🔥 e', e);
          stopResponse(e.message || '未知异常！');
        });
    },
    invalidCheck(str) {
      return /抱歉/.test(str);
    },
    staffserviceCheck(str) {
      return /人工|投诉/.test(str);
    },
    getAssistantAnswer(question) {
      if (question) this.qaList.push(this.buildChatItem('user', question));
      this.getTextStream(this.apiMap.assistantQa, {
        accountNo: localStorage.getItem('username'),
        appId: this.appId,
        currNodeInstanceId: this.currNodeInstanceId,
        modelUserContent: question,
        orgId: 'yxt',
        processStatus: this.processStatus,
        recordId: this.finalRecordId,
        platform: this.platform,
        ...this.carryParmas
      }, {
        callback: (data, loading, info) => {
          this.qaLoading = loading;
          this.sessionId = info.recordId;
          if (!this.qaLoading) this.receiveStatus = 4;
          if (this.modelMsgDialogVisible) {
            this.modelMsg = data;
          } else {
            this.qaList[this.qaList.length - 1].content = data;
            this.viewBottom(this);
          }
        },
        parseHandle: (resData, receivedData) => {
          // if (resData.id) this.sessionId = resData.id;
          if (resData.curr_node_instanceId) this.currNodeInstanceId = resData.curr_node_instanceId;
          if (resData.feedback_type === 'dialog') {
            receivedData.data = '';
            this.modelMsgDialogVisible = true;
          };
          if (resData.feedback_type === 'chat') {
            const lastChatItem = this.qaList[this.qaList.length - 1];
            if (lastChatItem.content) {
              this.qaList.push(this.buildChatItem('assistant', ''));
              receivedData.data = '';
              this.viewBottom(this);
            };
          }
          if (resData.code === 'AI_506') {
            this.processFinish = true;
            this.qaLoading = false;
            this.$emit('processEnd', this.qaList[this.qaList.length - 1].content);
          }
        }
      });
      this.qaList.push(this.buildChatItem('assistant', ''));
      this.processStatus = 'continue';
    },
    assistantContinue() {
      this.modelMsgDialogVisible = false;
      this.onGetAnswer();
    },
    async onGetAnswer(question) {
      this.receiveStatus = 1;
      this.qaLoading = true;
      if (this.apiMap.sessionGenerate && !this.sessionId) {
        this.sessionId = await this.generateSession(question).catch(() => {
          this.qaLoading = false;
          const msg = '创建会话失败！';
          this.$fmessage.error(msg);
          throw new Error(msg);
        });
      };
      if (question) this.qaList.push(this.buildChatItem('user', question));
      this.$refs.chatInputRef.clearQuestion();

      if (this.enableStaffservice && this.staffserviceCheck(question) && this.qaList.length !== 0) {
        this.qaLoading = false;
        const chatItem = this.buildChatItem('assistant', '');
        chatItem.type = 'staffservice';
        this.qaList.push(chatItem);
        this.viewBottom(this);
        return;
      };

      const handleMap = {
        assistant: this.getAssistantAnswer
      };
      const handle = handleMap[this.appData.type];
      handle ? handle(question) : this.$message({
        message: `${this.appData.type}类型的应用即将上线，敬请期待！`
      });
      setTimeout(() => {this.receiveStatus = 2;this.viewBottom(this);}, 200);
    },
    resetProcess() {
      this.clearQaList();
      this.currNodeInstanceId = 'start-0';
      this.processStatus = '';
      this.processFinish = false;
      this.sessionId = '';
      this.onGetAnswer();
    },
    goToBottom() {
      this.$nextTick(() => {
        this.$refs.chatBoxRef && this.$refs.chatBoxRef.$el.scrollIntoView({ block: 'end' });
      });
    },
    // 存在多个数据同时返回的情况，时间临时写小点
    viewBottom: throttle(30, false, (t) => {
      if (t.$refs.chatBoxRef) t.$nextTick(() => {t.$refs.chatBoxRef.$el.scrollIntoView({ behavior: 'smooth', block: 'end' });});
    }, false)
  },
  watch: {
    modelMsgDialogVisible(val) {
      if (val) {
        const lastChatItem = this.qaList[this.qaList.length - 1];
        lastChatItem.content === '' && this.qaList.pop();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
